<template>
  <v-app>
    <v-container fluid grid-list-lg>
        <v-card>          
          <v-app-bar flat>
            <v-icon>question_answer</v-icon>
            <v-toolbar-title class="font-weight-light">&nbsp;ABM de Respuestas de Gestión</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{on}">
                <v-btn text icon color="red" v-on="on" @click="setStatusTareaFrecuente(action)">
                  <v-icon v-if="action.esFrecuente">favorite</v-icon>
                  <v-icon v-else>favorite_border</v-icon>
                </v-btn>
              </template>
              <span v-if="action.esFrecuente">Quitar de Tareas Frecuentes</span>  
              <span v-else>Agregar a Tareas Frecuentes</span>  
            </v-tooltip>
          </v-app-bar>
          <v-card-text>
            <v-layout  wrap >               
                <v-flex xs12 sm6 md6 lg6>
                  <v-card>
                    <v-app-bar flat dense :color="$store.state.UiColors.crudToolbarList">
                      <v-icon>list</v-icon>
                      <v-toolbar-title class="font-weight-light">Lista</v-toolbar-title>
                      <v-spacer></v-spacer>                      
                    </v-app-bar>

                    <v-flex right>
                      <v-text-field
                          clearable
                          v-model="search"
                          append-icon="search"
                          label="Buscar por Descripción"
                          single-line
                          hide-details
                      ></v-text-field>
                    </v-flex>

                    <v-data-table 
                      :headers="headers"
                      :items="records"
                      :server-items-length="totalItems"
                      :loading="loading"
                      :options.sync="options"
                      v-model="selectedRow"
                      :footer-props="{itemsPerPageOptions:options.rowsPerPageItems}"
                    >
                      <template slot="no-data">
                        <v-alert :value="true" color="grey" icon="warning">
                          No se encontraron datos
                        </v-alert>
                      </template>
                      <template v-slot:item="{ item }">                
                        <tr @click="viewItem(item)">
                            <td class="text-xs-left">{{ item.descripcion }}</td>
                            <td class="text-xs-left">{{ item.tipoGestionDescripcion }}</td>
                            
                            <td class="text-xs-left">                
                            <v-icon small class="mr-2" @click="editItem(item)" v-show="canUpdate">edit</v-icon>
                            <v-icon small  @click="deleteItem(item)" v-show="canDelete">delete</v-icon></td>
                        </tr>
                      </template>
                    </v-data-table>
                    
                  </v-card >
                </v-flex>
                
                <v-flex xs12 sm6 md6 lg6>
                  <v-card >
                    <v-app-bar flat dense :color="$store.state.UiColors.crudToolbarDetail">
                      <v-icon>question_answer</v-icon>
                      <v-toolbar-title class="font-weight-light">Detalle</v-toolbar-title>
                      <v-spacer></v-spacer>
                      
                      <v-btn v-if="!editMode" :color="$store.state.UiColors.crudToolbarDetailButtons" fab small top @click="editItem()" v-show="canCreate">
                        <v-icon medium>add_circle_outline</v-icon>
                      </v-btn>
                      
                      <v-btn v-if="model.id != null" 
                        :color="$store.state.UiColors.crudToolbarDetailButtons" fab small top @click="editMode = !editMode" v-show="canUpdate">
                        <v-icon v-if="editMode">cancel</v-icon>
                        <v-icon v-else>edit</v-icon>
                      </v-btn>
                    </v-app-bar>
                    <v-card-text>
                      <v-form :disabled="!editMode">
                          <v-text-field v-model="model.descripcion" label="Descripción" required :disabled="!editMode" v-validate="'required'"
                                         data-vv-name="descripcion" :error-messages="errors.collect('descripcion')"></v-text-field>

                            <v-row>
                                <v-col cols="4">                                    
                                  <v-autocomplete v-model="model.tipoGestionId" :items="tiposGestion" 
                                      item-text="descripcion" item-value="id" label="Tipo de Gestión" placeholder="Seleccione un tipo de gestión" 
                                      :disabled="!editMode"></v-autocomplete>
                                </v-col>
                                <v-col cols="4">                                    
                                  <v-checkbox label="Es Contacto" v-model="model.esContacto" :disabled="!editMode" ></v-checkbox>
                                </v-col>
                                <v-col cols="4">                                    
                                  <v-checkbox label="Rellamar" v-model="model.rellamar" :disabled="!editMode" ></v-checkbox>
                                </v-col>

                            </v-row>
                        <template v-if="$store.state.debugModeOn">
                        Debug Info: <p></p>
                        
                        Model: {{model}}  <p></p>                            
                        </template>
                        <v-divider></v-divider>

                        <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="success" :disabled="!editMode" @click="saveItem"><v-icon>save</v-icon>Guardar</v-btn>
                        </v-card-actions>

                        </v-form>
                    </v-card-text>
                  </v-card>
                </v-flex>
              
            </v-layout>
          </v-card-text>
        </v-card >
       
    </v-container>
</v-app>
</template>

<script>

import { http } from '@/axios'
import Vue from 'vue'
import {
  mapState,
  mapGetters,
  mapMutations,
  mapActions
} from 'vuex'

export default {
  data() {
    return {
      loading: false,
      editMode: false,
      suspend: false,
      search: '', // valor para búsqueda
      options: { // definición de paginación
        sortDesc:[false],
        sortBy:[''],
        page: 1,
        itemsPerPage: 5,
        rowsPerPageItems:[5,10,20]
      },
      totalItems: 0, // va afuera de options
      headers: [ // definición de columnas
        { text: 'Descripción', value: 'descripcion', align: 'left'},
        { text: 'Tipo de Gestión', value: 'tipoGestionDescripcion',sortable:false},
        { text: 'Acciones', value: 'name', sortable: false }
      ],        
      records: [], // registros
      selectedRow: [],
      model: {},
      tiposGestion: [],
      respuestasGestion:[]
    };
  },
  async created() {     
      this.getItems();
      this.loadTiposGestion();
  },
  watch: {
    options :{
        handler(){
          this.getItems();
        },
        deep: true
    },
    search() {
        this.getItems();
    }
  },
  computed: {
    ...mapGetters(['checkCanCreate', 'checkCanUpdate', 'checkCanDelete','getActionFromLink']),
    canCreate: function(){
      return this.checkCanCreate(this.$route.path)
    },
    canUpdate: function(){
      return this.checkCanUpdate(this.$route.path)
    },
    canDelete: function(){
      return this.checkCanDelete(this.$route.path)
    },
    action: function(){
      return this.getActionFromLink(this.$route.path)
    }
  },
  methods: {
    ...mapMutations(["alertClear", "alertSuccess", "alertWarning", "alertError"]),
    ...mapActions(['setStatusTareaFrecuente']),
    async getItems() {
      this.loading = true
      this.$validator.reset()

      try {
        var result = await http.get('gestion/listrespuestasgestion?descripcion='+this.search + '&limit='+this.options.itemsPerPage+'&page='+this.options.page+
                                    '&sortby='+this.options.sortBy+'&descending='+(this.options.sortDesc.length > 0 ? this.options.sortDesc : 'false') );                                
        
        this.records = result.list;
        this.totalItems = result.totalCount;
      } catch (error) {
        // Error
        this.alertError(error)
      }
      this.loading = false
    },
    async resetState(){      
      this.$validator.reset()
      this.editMode = false;
    },
    async getItem(id) {
      this.loading = true
      this.resetState()

      try {
        var result = await http.get('gestion/getrespuestagestionbyid/'+id);

        this.model = result;
      } catch (error) {
        // Error        
        this.alertError(error)
      }
      
      this.loading = false
    },    
    async viewItem(item){
      if(this.suspend) return;

      this.selectedRow.pop()
      this.selectedRow.push(item)

      await this.getItem(item.id);
      this.editMode = false;      
    },
    async clearAndReload(){
        // Clear the data inside of the form
        this.model = {}
        this.resetState()

        // Refresco la grilla
        await this.getItems()
    },
    async editItem(item){
      this.suspend = true; // hago esto porque se dispara también el evento click del row (que llama a viewItem)

      if(!item)
        await this.getItem(0);
      else
        await this.getItem(item.id);
      
      this.editMode = true;
      this.suspend = false;
    },
    async cancelEdit() {
      this.editMode = false;
    },
    async saveItem() {
      const isUpdate = !!this.model.id;
      await this.$validator.validateAll()
      
      if(this.errors.items.length > 0) return;
      
      if (isUpdate) {
        try{
          var result = await http.put('gestion/updaterespuestagestion', JSON.stringify( {respuesta:  this.model} ) );
          this.alertSuccess('Los cambios han sido guardados.')
          this.clearAndReload();
        } 
        catch(error){
          // Error
          this.alertError(error)
        }               
      } else {
        try{
          var result = await http.post('gestion/createrespuestagestion', JSON.stringify( {respuesta:  this.model} ) );
          this.alertSuccess('Los cambios han sido guardados.')
          this.clearAndReload();
        } 
        catch(error){
          // Error
          Vue.$log.error(error);
          this.alertError(error)
        }         
      }
    },
    async deleteItem(item) {      
      if (confirm('¿Confirma la eliminación de la respuesta ' + item.descripcion + '?')) {
        try{
            Vue.$log.debug(item);
            var result = await http.delete('gestion/deleterespuestagestion?id='+item.id );
            this.alertSuccess('La respuesta ha sido eliminada.')
            this.clearAndReload();
        }
        catch(error){
            //Error
            Vue.$log.error(error);
            if(error.includes("The DELETE statement conflicted with the REFERENCE constraint")){
              this.alertError('La respuesta no puede ser eliminada debido a que está asociada a otras entidades.');
            } else {
              this.alertError(error)
            }
        }
      }
    },
    async loadTiposGestion(){
      this.loading = true;
      try{
        var result = await http.get('tiposgestion');

        this.tiposGestion = result.list;
      }
      catch(error){
        // Error
        this.alertError(error)
      }
      this.loading = false;
    }
  }
}
</script>